var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenderList',{attrs:{"region-name":_vm.regionName,"region-id":_vm.regionId}}),_vm._v(" "),_c('AgeBandList',{attrs:{"region-name":_vm.regionName,"region-id":_vm.regionId}}),_vm._v(" "),_c('PickupList',{attrs:{"region-name":_vm.regionName,"region-id":_vm.regionId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }